import Vue from 'vue'
import Vuex from 'vuex'
window.Vue = Vue;

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {},
        dashboard: [],
        title: '',
        active: '0',
        breadcrumb: [],
        notification: '',
        searchHeader: false,
        money: {},
        config: {},
        loading: false,
        errorPutRv: {},
    },
    mutations: {
        dataUser(state, data) {
            state.user = data;
        },
        dataDashboard(state, data) {
            state.dashboard = data;
        },
        dataTitle(state, data) {
            state.title = data;
        },
        dataActive(state, data) {
            state.active = data;
        },
        dataNotification(state, data) {
            state.notification = data;
        },
        dataBreadcrumb(state, data) {
            state.breadcrumb = data;
        },
        dataSearchHeader(state, data) {
            state.searchHeader = data;
        },
        dataMoney(state, data) {
            state.money = {
                unit:       data.unit,
                money:      data.money,
                money_text: data.money_text
            };
        },
        dataConfig(state, data) {
            state.config = data;
        },
        dataLoading(state, data) {
            state.loading = data;
        },
        dataErrorPutRv(state, data) {
            state.errorPutRv = data;
        },
    },
})
